import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the comparativeAnalysis state domain
 */

const selectComparativeAnalysisDomain = (state) =>
  state.get("comparativeAnalysis", initialState)

/**
 * Other specific selectors
 */

/**
 * Default selector used by ComparativeAnalysis
 */

export const makeSelectIsLoading = () =>
  createSelector(selectComparativeAnalysisDomain, (state) =>
    state.get("isLoading")
  )

export const makeSelectIsLoadingHeaders = () =>
  createSelector(selectComparativeAnalysisDomain, (state) =>
    state.get("isLoadingHeaders")
  )

export const makeSelectHeaders = () =>
  createSelector(selectComparativeAnalysisDomain, (state) =>
    state.get("headers")
  )

export const makeSelectDivisions = () =>
  createSelector(selectComparativeAnalysisDomain, (state) =>
    state.get("divisions")
  )

export const makeSelectMeasureGeneral = () =>
  createSelector(selectComparativeAnalysisDomain, (state) =>
    state.get("measure_general")
  )

export const makeSelectDivisionTotal = () =>
  createSelector(selectComparativeAnalysisDomain, (state) =>
    state.get("divisionsTotal")
  )

export const makeSelectIndicatorLoading = () =>
  createSelector(selectComparativeAnalysisDomain, (state) =>
    state.get("indicatorLoading")
  )

export const makeSelectIndicator = () =>
  createSelector(selectComparativeAnalysisDomain, (state) =>
    state.get("indicator")
  )

export const makeSelectFiltersDivisions = () =>
  createSelector(selectComparativeAnalysisDomain, (state) =>
    state.get("filters_divisions")
  )
  export const makeSelectFiltersSegments = () =>
  createSelector(selectComparativeAnalysisDomain, (state) =>
    state.get("filters_segments")
  )

export const makeSelectCountEmployees = () =>
  createSelector(selectComparativeAnalysisDomain, (state) =>
    state.get("employees")
  )

export const makeSelectMeasureInfo = () =>
  createSelector(selectComparativeAnalysisDomain, (state) =>
    state.get("measureInfo")
  )

export const makeSelectMeasureRangeColor = () =>
  createSelector(selectComparativeAnalysisDomain, (state) =>
    state.get("measureColorRange")
  )

export const makeSelectLastPage = () =>
  createSelector(selectComparativeAnalysisDomain, (state) =>
    state.get("lastPage")
  )

const makeSelectComparativeAnalysis = () =>
  createSelector(selectComparativeAnalysisDomain, (substate) => substate.toJS())

export default makeSelectComparativeAnalysis
export { selectComparativeAnalysisDomain }
